/** Human-readable label for a source slug (mobile_de → Mobile.de). */
export function sourceDisplayName(name: string): string {
  const labels: Record<string, string> = {
    autoscout24: 'AutoScout24',
    kleinanzeigen: 'Kleinanzeigen',
    mobile_de: 'Mobile.de',
    njuskalo: 'Njuskalo',
  };
  if (labels[name]) return labels[name];
  return name
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function categoryDisplayName(category: string): string {
  const labels: Record<string, string> = {
    vehicles: 'Vehicles',
    real_estate: 'Real estate',
    apartments: 'Apartments',
    jobs: 'Jobs',
    marketplace: 'Marketplace',
  };
  return labels[category] ?? category.replace(/_/g, ' ');
}
